import PropTypes from 'prop-types';

const defaultOptions = {};

const RoleTypeInput = ({ _source, _options = defaultOptions, ..._rest }) => {
    return null;
};

RoleTypeInput.propTypes = {
    options: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default RoleTypeInput;
